export const version = '0.13.32';



// WEBPACK FOOTER //
// /home/travis/build/inspirehep/record-editor/src/environments/version.ts